import React, { useEffect, useState } from "react";
import { api, fmtEUR } from "../../lib/api";
import { Link } from "react-router-dom";

export default function SupporterDashboard() {
  const [donations, setDonations] = useState([]);
  const [following, setFollowing] = useState([]);

  useEffect(() => {
    (async () => {
      const [d, f] = await Promise.all([
        api.get("/me/donations"),
        api.get("/me/following"),
      ]);
      setDonations(d.data);
      setFollowing(f.data);
    })();
  }, []);

  const total = donations.reduce((acc, d) => acc + (d.amount || 0), 0);

  return (
    <div data-testid="supporter-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-0 border border-border mb-10">
        <Stat k="Total donated" v={fmtEUR(total)} />
        <Stat k="Athletes backed" v={new Set(donations.map((d) => d.athlete_id)).size} />
        <Stat k="Following" v={following.length} last />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        <section>
          <div className="overline mb-4">Golfers you follow</div>
          {following.length === 0 ? (
            <div className="border border-border p-6 text-foreground/60">
              You're not following any golfers yet. <Link to="/golfers" className="text-primary underline">Browse</Link> to find someone to back.
            </div>
          ) : (
            <ul className="divide-y divide-border border-y border-border" data-testid="supporter-following">
              {following.map((a) => (
                <li key={a.athlete_id} className="py-4 flex items-center gap-4">
                  <img src={a.image_url} alt="" className="w-12 h-12 object-cover" />
                  <div className="flex-1">
                    <Link to={`/golfers/${a.slug || a.athlete_id}`} className="font-display text-xl hover:text-primary">{a.name}</Link>
                    <div className="text-xs text-foreground/60">{[a.country, a.tour_level].filter(Boolean).join(" · ")}</div>
                  </div>
                  <div className="text-sm text-right">
                    <div className="font-display text-lg">{fmtEUR(a.funding_raised)}</div>
                    <div className="overline text-foreground/60">raised</div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>

        <section>
          <div className="overline mb-4">Your donations</div>
          {donations.length === 0 ? (
            <div className="border border-border p-6 text-foreground/60">No donations yet, your impact starts here.</div>
          ) : (
            <ul className="divide-y divide-border border-y border-border" data-testid="supporter-donations">
              {donations.map((d) => (
                <li key={d.donation_id} className="py-4 flex items-baseline justify-between">
                  <div>
                    <div className="font-medium">Donation to golfer</div>
                    <div className="text-xs text-foreground/60">{new Date(d.created_at).toLocaleDateString()} · {d.type}</div>
                  </div>
                  <div className="font-display text-xl">{fmtEUR(d.amount)}</div>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
}

function Stat({ k, v, last }) {
  return (
    <div className={`p-6 ${!last ? "md:border-r border-border" : ""}`}>
      <div className="overline text-foreground/60">{k}</div>
      <div className="font-display text-3xl mt-2">{v}</div>
    </div>
  );
}
